import type { StateTree } from '@makemydeal/dr-dash-types';
import { getCurrentAppraisalByVin } from './vAutoSelectors';

export const getVAutoTriforceState = (state: StateTree) => {
    return state.vAutoTriforce;
};

export const getVAutoTriforceDataByVin = (vin: string) => (state: StateTree) => {
    const appraisal = getCurrentAppraisalByVin(vin)(state);
    if (!appraisal?.id) {
        return;
    }
    return getVAutoTriforceState(state)?.[appraisal.id]?.data;
};
